import React, { useState } from "react";

const SearchBar = ({ onSearch, isPageAdmin = false }) => {
  const [searchValue, setSearchValue] = useState("");

  const handleInputChange = (event) => {
    setSearchValue(event.target.value);
    onSearch(event.target.value);
  };

  const searchBar = isPageAdmin ? (
    <div className="searchbox w-1/4 mb-4 relative">
      <input
        type="text"
        value={searchValue}
        onChange={handleInputChange}
        placeholder="Search user by name, email ..."
        className="py-3 px-2 block w-full rounded-md text-sm focus:border-coc-green focus:ring-coc-green bg-[#F9F9F9] border-[#DEDEDE]"
      />
      <svg
        className="w-6 h-6 absolute top-0 right-[1rem] translate-y-1/2 text-[#474747]"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
        />
      </svg>
    </div>
  ) : (
    <div className="flex items-center max-w-md mx-auto p-2 bg-white rounded-full shadow-lg hover:border-green-500">
      <svg
        className="h-5 w-5 text-coc-blue mx-3"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        value={searchValue}
        onChange={handleInputChange}
        placeholder="Search..."
        className="outline-none bg-transparent w-full text-gray-700 placeholder-gray-500 border-none focus:ring-0"
      />
    </div>
  );

  return searchBar;
};

export default SearchBar;
